// magic numbers

/**
 * Mean passenger weight in kg.
 *
 * rounded to nearest kg based on mean weight adult NZ in 2023 combined for
 * genders and ethnicity category (this does not take into account the
 * density of the sample groups).
 */
export const meanPassengerWeight = 85 // TODO: find better solution that google search data.

/**
 * Max number of waypoints ev nav route planning can support.
 */
export const evNavMaxWaypoints = 2

/**
 * The maximum number of locations a valhalla route call can take at its worst costing type of auto.
 */
export const maxValhallaLocations = 20

// alerts text

export const deleteVehicleAlertData = {
  title: 'Delete your vehicle...',
  message: 'This will permanently delete your vehicle and cannot be undone.',
}

export const changeItineraryAlertData = {
  title: 'This will change your itinerary...',
  message:
    'This might make changes further on in your itinerary Make sure to save this trip first before replanning.',
}

export const optimiseStopsAlertData = {
  title: 'Optimise the order of your stops?',
  message:
    'Are you sure you want to optimise your stops. This will change the order of stops to the most efficient route for your trip and charging needs.',
}

export const potentialBrokenTripAlertData = {
  title: 'This may break your trip...',
  message:
    'These changes to your itinerary might break your current trip. Make sure to save this trip first before replanning.',
}

export const cancelBookingAlertData = {
  title: 'Cancel your booking...',
  message: 'This will remove your booking and cannot be undone.',
}
